module.exports = __webpack_public_path__ + "img/EGCSScrubber-dark.b4f34a5b.svg";